'use client';

import {
  getAemCallbackURL,
  getCurrentProductConfigurationURL,
  getFallbackURL,
} from '@storefront/services/SessionHelperService/sessionHelperService';
import ErrorInformation from '@storefront/shared-components/error-information/error-information';
import { useTranslation } from 'react-i18next';

import styles from '../app/pdp-config/error.p.module.scss';
import Header from '../shared-components/header/header';

export default function NotFound() {
  const { t } = useTranslation('common', {
    keyPrefix: 'errors.PAGE_NOT_FOUND',
  });

  return (
    <div className={styles['container']}>
      <Header />
      <ErrorInformation
        errorId={'PageNotFound'}
        code={t(`code`)}
        title={t(`title`)}
        description={t(`description`)}
        buttonDetails={{
          redirectToURL: t('redirectUrl', {
            aemURL: getAemCallbackURL() ?? getFallbackURL(),
            hpStoreURL: getFallbackURL(),
          }),
          label: t('buttonLabel'),
        }}
        redirectLink={{
          title: t('redirectTitle'),
          link: t('redirectLink', {
            currentProductConfigurationURL:
              getCurrentProductConfigurationURL() ?? getFallbackURL(),
          }),
        }}
      />
    </div>
  );
}
